'use client'

import { AllPurchasesError } from 'my-purchases/components/AllPurchasesError/AllPurchasesError'
import { LoadMoreButton } from 'my-purchases/components/LoadMoreButton/LoadMoreButton'
import { Loading } from 'my-purchases/components/Loading/Loading'
import { PurchaseList } from 'my-purchases/components/PurchaseList/PurchaseList'
import { NoPurchasesContainer } from 'my-purchases/containers/NoPurchasesContainer/NoPurchasesContainer'
import { usePurchases } from 'my-purchases/hooks/usePurchases/usePurchases'
import { sendOnLoadingError } from 'my-purchases/utils/analytics/analyticsEvents'

import { PartialPurchasesError } from 'my-purchases/components/PartialPurchasesError/PartialPurchasesError'
import styles from './PurchasesListContainer.module.scss'

export function PurchasesListContainer() {
	const { purchases, error, isLoading, reload, loadMore, showLoadMoreButton } =
		usePurchases()

	if (isLoading && purchases?.length === 0) {
		return <Loading />
	}

	if (error && purchases?.length === 0) {
		sendOnLoadingError()
		return <AllPurchasesError retryCallback={reload} />
	}

	if (!purchases) {
		return null
	}

	if (purchases?.length === 0) {
		return <NoPurchasesContainer />
	}

	return (
		<div className={styles.container}>
			<PurchaseList purchases={purchases} />

			{(showLoadMoreButton || (purchases.length > 0 && isLoading)) && (
				<LoadMoreButton handleClick={loadMore} isLoading={isLoading} />
			)}

			{error && <PartialPurchasesError reload={reload} />}
		</div>
	)
}
